import {
  FIND_USER_BY_ID,
  // FIND_NOTIFICATION_PREFERENCES_BY_USER_ID,
  PROFILE_PAGE,
} from '@/graphql/queries/profile/profile';
import { initializeApollo } from '../lib/apollo-client';
import requestHandler from '../requestHandler';
import {
  ChangePasswordMutation,
  ChangePasswordMutationVariables,
  FindUsersPermissionsUserByIdQuery,
  FindUsersPermissionsUserByIdQueryVariables,
  // GetNotificaitonPreferencesByUserIdQuery,
  // GetNotificaitonPreferencesByUserIdQueryVariables,
  ProfilePage,
  ProfilePageQuery,
  ProfilePageQueryVariables,
  UpdateUserMutation,
  UpdateUserMutationVariables,
  UsersPermissionsUserEntity,
  UsersPermissionsUserInput,
} from '@/graphql/generated/graphql';
import { Observable } from '@apollo/client';

import { MUTATION_CHANGE_PASSWORD, MUTATION_UPDATE_USER } from '@/graphql/mutations/user/update-user';
// import { getAuthentication } from '@/hooks/useAuthentication';

export const getUserById = async (id: string) => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<FindUsersPermissionsUserByIdQuery, FindUsersPermissionsUserByIdQueryVariables>({
      query: FIND_USER_BY_ID,
      variables: { id },
    }),
  );

  return {
    user: data?.usersPermissionsUser?.data as UsersPermissionsUserEntity,
    error,
  };
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
export const watchUserById = (id: string) => {
  const apolloClient = initializeApollo();

  const pollInterval = 60 * 1000 * 5; // 5 minutes
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const observable: Observable<any> = apolloClient.watchQuery({
    query: FIND_USER_BY_ID,
    variables: { id },
    pollInterval,
  });

  return observable;
};

// export const getNotificationPreferencesByUserId = async () => {
//   const apolloClient = initializeApollo();

//   const { data, error } = await requestHandler(
//     apolloClient.query<GetNotificaitonPreferencesByUserIdQuery, GetNotificaitonPreferencesByUserIdQueryVariables>({
//       query: FIND_NOTIFICATION_PREFERENCES_BY_USER_ID,
//       variables: { userId: getAuthentication()?.user?.id },
//     }),
//   );

//   return {
//     notificationEntityId: data?.notificationPreferences?.data?.[0].id,
//     preferences: data?.notificationPreferences?.data?.[0].attributes?.preferences,
//     error,
//   };
// };

export const updateUser = async (id: string, input: UsersPermissionsUserInput) => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.mutate<UpdateUserMutation, UpdateUserMutationVariables>({
      mutation: MUTATION_UPDATE_USER,
      variables: {
        id,
        input,
      },
    }),
  );

  return {
    data,
    error,
  };
};

export const updatePassword = async ({
  currentPassword,
  password,
  passwordConfirmation,
}: {
  currentPassword: string;
  password: string;
  passwordConfirmation: string;
}) => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<ChangePasswordMutation, ChangePasswordMutationVariables>({
      query: MUTATION_CHANGE_PASSWORD,
      variables: {
        currentPassword,
        password,
        passwordConfirmation,
      },
    }),
  );

  return {
    data,
    error,
  };
};

export const getPage = async () => {
  const apolloClient = initializeApollo();

  const { data, error } = await requestHandler(
    apolloClient.query<ProfilePageQuery, ProfilePageQueryVariables>({
      query: PROFILE_PAGE,
    }),
  );

  return {
    page: data?.profilePage?.data?.attributes as ProfilePage,
    error,
  };
};
